export default __webpack_public_path__ + "static/media/bnb-fine-closed-logo.6624cd48.svg";